import { render, staticRenderFns } from "./CaregiverDetail.vue?vue&type=template&id=2b052c24&scoped=true"
import script from "./CaregiverDetail.vue?vue&type=script&lang=js"
export * from "./CaregiverDetail.vue?vue&type=script&lang=js"
import style0 from "./CaregiverDetail.vue?vue&type=style&index=0&id=2b052c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b052c24",
  null
  
)

export default component.exports